import api from '../Axios';

export const fetchUserDashboardAPI = async (userCode: string) => {
  const response = await api.get(`/api/user-dashboard/${userCode}`);
  return response.data;
};

export const logoutUserAPI = async () => {
  const response = await api.post('/api/user-auth/logout');
  return response.data;
};

// 🟢 FIXED: Add userCode parameter and inject it into the URL
export const updateUserProfileAPI = async (userCode: string, formData: FormData) => {
  const response = await api.put(`/api/user-dashboard/profile/${userCode}`, formData);
  return response.data;
};